import { render, staticRenderFns } from "./inventoryOverTopDetail.vue?vue&type=template&id=0df58f9c&scoped=true&"
import script from "./inventoryOverTopDetail.vue?vue&type=script&lang=js&"
export * from "./inventoryOverTopDetail.vue?vue&type=script&lang=js&"
import style0 from "./inventoryOverTopDetail.vue?vue&type=style&index=0&id=0df58f9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df58f9c",
  null
  
)

export default component.exports